var _defs, _polygon, _g, _g2, _g3, _g4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1502.96 991.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-61);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-4 {\n        fill: #1759ba;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-6, .cls-7 {\n        fill: #1d425d;\n      }\n\n      .cls-6, .cls-8, .cls-9 {\n        opacity: .5;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-65);\n      }\n\n      .cls-11 {\n        opacity: .75;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-14 {\n        fill: #f4ce78;\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-60);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-17 {\n        fill: #0951ba;\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-64);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-20 {\n        stroke-width: 1.02px;\n      }\n\n      .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29 {\n        fill: none;\n      }\n\n      .cls-20, .cls-30, .cls-22, .cls-31, .cls-32, .cls-24, .cls-33, .cls-27, .cls-34, .cls-35 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-20, .cls-30, .cls-31, .cls-32, .cls-25, .cls-26, .cls-33, .cls-27, .cls-28 {\n        stroke: #fff;\n      }\n\n      .cls-36 {\n        fill: #001a30;\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-21 {\n        stroke: #001a30;\n        stroke-width: .36px;\n      }\n\n      .cls-21, .cls-23, .cls-25, .cls-26, .cls-28, .cls-29 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-30, .cls-31, .cls-32, .cls-33 {\n        stroke-width: 1.64px;\n      }\n\n      .cls-41 {\n        fill: #00be84;\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49 {\n        opacity: .15;\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-22 {\n        stroke: #332a97;\n      }\n\n      .cls-22, .cls-24, .cls-25 {\n        stroke-width: .71px;\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-52, .cls-34 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-54 {\n        fill: #8e6464;\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-23 {\n        stroke: #1860d3;\n        stroke-width: 3.03px;\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-56 {\n        opacity: .25;\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-57 {\n        fill: #4888e5;\n      }\n\n      .cls-58 {\n        fill: #9ff7ff;\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-60 {\n        fill: #f4ab7a;\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-62 {\n        fill: #3dba85;\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-24 {\n        stroke: #158489;\n      }\n\n      .cls-63 {\n        fill: #d8e1ef;\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-67 {\n        fill: #13d393;\n      }\n\n      .cls-68 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-26 {\n        stroke-width: 1.78px;\n      }\n\n      .cls-70 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-71 {\n        fill: #3f86ed;\n      }\n\n      .cls-72 {\n        fill: #f2f2f2;\n      }\n\n      .cls-73 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-74 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-75 {\n        fill: #fca358;\n      }\n\n      .cls-76 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-78 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-79 {\n        fill: url(#linear-gradient-66);\n      }\n\n      .cls-80 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-81 {\n        fill: #ffb0da;\n      }\n\n      .cls-82 {\n        fill: #1450a8;\n      }\n\n      .cls-83 {\n        fill: #4488ea;\n      }\n\n      .cls-84 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-85 {\n        fill: url(#linear-gradient-62);\n      }\n\n      .cls-86 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-87 {\n        fill: #f99316;\n      }\n\n      .cls-88 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-89 {\n        fill: url(#linear-gradient-67);\n      }\n\n      .cls-90 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-91 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-92 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-93 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-94 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-95 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-96 {\n        fill: #1860d3;\n      }\n\n      .cls-27 {\n        stroke-width: 3.46px;\n      }\n\n      .cls-97 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-34 {\n        stroke: #231f20;\n        stroke-width: .76px;\n      }\n\n      .cls-98 {\n        fill: #1f2024;\n      }\n\n      .cls-99 {\n        fill: #e5f7f7;\n      }\n\n      .cls-28 {\n        stroke-width: 2.97px;\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-100 {\n        fill: #0562e8;\n      }\n\n      .cls-101 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-102 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-29 {\n        stroke: #ff4295;\n        stroke-width: 1.43px;\n      }\n\n      .cls-103 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-104 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-35 {\n        fill: #deebff;\n        stroke: #2f6bc1;\n        stroke-width: 1.45px;\n      }\n\n      .cls-105 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-106 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-107 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-108 {\n        fill: #1a3099;\n      }\n\n      .cls-109 {\n        fill: url(#linear-gradient-63);\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-110 {\n        fill: #0b4dad;\n      }\n\n      .cls-111 {\n        fill: url(#linear-gradient-18);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8833.64,
    y1: 537.33,
    x2: 8869.14,
    y2: 537.33,
    gradientTransform: "translate(7172.45 4444.21) rotate(-142.72) scale(.85 -1.17) skewX(-27.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d35400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb62d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 8833.64,
    y1: 541.15,
    x2: 8869.14,
    y2: 541.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 8833.64,
    y1: 544.97,
    x2: 8869.14,
    y2: 544.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1104.99,
    y1: 767.49,
    x2: 1043.01,
    y2: 705.51,
    gradientTransform: "translate(-136.51 -252.21) rotate(2.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1100.25,
    y1: 847.9,
    x2: 1050.31,
    y2: 702.86,
    gradientTransform: "translate(-136.51 -252.21) rotate(2.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1131.21,
    y1: 833.23,
    x2: 1055.76,
    y2: 609.02,
    gradientTransform: "translate(-136.51 -252.21) rotate(2.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1150.09,
    y1: 756.71,
    x2: 1117.15,
    y2: 712.61,
    gradientTransform: "translate(-136.51 -252.21) rotate(2.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 9613.03,
    y1: 671.5,
    x2: 9640.3,
    y2: 671.5,
    gradientTransform: "translate(10533.97 -206.12) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 795.44,
    y1: 1004.75,
    x2: 841.41,
    y2: 958.78,
    gradientTransform: "translate(-295.74 -553.21) rotate(5.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05a1e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0562e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 784.9,
    y1: 1063.05,
    x2: 863.64,
    y2: 984.31,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 731.43,
    y1: 1009.58,
    x2: 810.17,
    y2: 930.84,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 881.64,
    y1: 1074.98,
    x2: 974.54,
    y2: 1074.98,
    gradientTransform: "translate(-295.74 -553.21) rotate(5.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1206.44,
    y1: 271.5,
    x2: 1251.52,
    y2: 215.78,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1223.67,
    y1: 285.44,
    x2: 1268.75,
    y2: 229.72,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1166.61,
    y1: 229.89,
    x2: 1199.11,
    y2: 229.89,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 5198.02,
    y1: 1867.17,
    x2: 5230.52,
    y2: 1867.17,
    gradientTransform: "translate(-4015.16 -1674.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 9339.55,
    y1: 229.89,
    x2: 9372.05,
    y2: 229.89,
    gradientTransform: "translate(-8062.55 459.78) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 10977.02,
    y1: -3911.83,
    x2: 11009.52,
    y2: -3911.83,
    gradientTransform: "translate(-9716.07 -3718.72) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 9242.56,
    y1: 178.36,
    x2: 9270.01,
    y2: 178.36,
    gradientTransform: "translate(-8017.65 .1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 9607.07,
    y1: 121.46,
    x2: 9646.75,
    y2: 121.46,
    gradientTransform: "translate(-8597.4 242.92) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 9619.12,
    y1: 132.46,
    x2: 9658.81,
    y2: 132.46,
    gradientTransform: "translate(-8621.5 264.91) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 9633.87,
    y1: 155.92,
    x2: 9754.05,
    y2: 155.92,
    gradientTransform: "translate(-8731.5 311.84) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 9692.5,
    y1: 163.61,
    x2: 9707.88,
    y2: 163.61,
    gradientTransform: "translate(10656.42) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 9651.28,
    y1: 163.61,
    x2: 9666.65,
    y2: 163.61,
    gradientTransform: "translate(10656.42) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3dba85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1de885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 9714.58,
    y1: 143.87,
    x2: 9729.96,
    y2: 143.87,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 9729.96,
    y1: 163.61,
    x2: 9745.33,
    y2: 163.61,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 975.2,
    y1: 320.59,
    x2: 996.83,
    y2: 320.59,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1120.93,
    y1: 461.07,
    x2: 1142.57,
    y2: 461.07,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 302.68,
    y1: 892.22,
    x2: 324.32,
    y2: 892.22,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 234.39,
    y1: 546.85,
    x2: 256.45,
    y2: 546.85,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 332.13,
    y1: 151.55,
    x2: 353.76,
    y2: 151.55,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 771.53,
    y1: 306.68,
    x2: 793.16,
    y2: 306.68,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 582.62,
    y1: 309.77,
    x2: 604.26,
    y2: 309.77,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 634.81,
    y1: 764.16,
    x2: 656.44,
    y2: 764.16,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1017.02,
    y1: 901.46,
    x2: 1038.65,
    y2: 901.46,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 237.99,
    y1: 281.08,
    x2: 350.18,
    y2: 281.08,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 266.98,
    y1: 297.33,
    x2: 283.3,
    y2: 297.33,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 251.5,
    y1: 321.67,
    x2: 267.79,
    y2: 321.67,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 267.08,
    y1: 300.19,
    x2: 279.56,
    y2: 300.19,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 255.25,
    y1: 318.81,
    x2: 267.7,
    y2: 318.81,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 245.64,
    y1: 343.62,
    x2: 291.22,
    y2: 343.62,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 251.67,
    y1: 342.5,
    x2: 260.82,
    y2: 342.5,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 295.08,
    y1: 343.62,
    x2: 340.67,
    y2: 343.62,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 245.64,
    y1: 368.35,
    x2: 291.22,
    y2: 368.35,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 295.08,
    y1: 368.35,
    x2: 340.67,
    y2: 368.35,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 265.27,
    y1: 682.34,
    x2: 398.14,
    y2: 682.34,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -328.61,
    y1: -1221.2,
    x2: -299.48,
    y2: -1221.2,
    gradientTransform: "translate(605.73 1929.72) rotate(-15.75) scale(.95 1.05) skewX(-15.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b91f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c54e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 308.22,
    y1: 707.61,
    x2: 313.59,
    y2: 686.53,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -285.59,
    y1: -1211.24,
    x2: -261.68,
    y2: -1211.24,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 334.92,
    y1: 710.66,
    x2: 348.33,
    y2: 685.86,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 822.3,
    y1: 713.79,
    x2: 898.31,
    y2: 713.79,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 832.35,
    y1: 711.93,
    x2: 847.62,
    y2: 711.93,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1049.35,
    y1: 327.55,
    x2: 1125.37,
    y2: 327.55,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 272.26,
    y1: 481.87,
    x2: 348.28,
    y2: 481.87,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1099.33,
    y1: 735.71,
    x2: 1118.8,
    y2: 735.71,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1040.92,
    y1: 789.22,
    x2: 1060.39,
    y2: 789.22,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1021.62,
    y1: 753.54,
    x2: 1041.1,
    y2: 753.54,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1079.86,
    y1: 771.38,
    x2: 1099.33,
    y2: 771.38,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1060.39,
    y1: 806.34,
    x2: 1079.86,
    y2: 806.34,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1021.62,
    y1: 735.71,
    x2: 1041.09,
    y2: 735.71,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 279.74,
    y1: 926.64,
    x2: 324.82,
    y2: 870.92,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 296.97,
    y1: 940.58,
    x2: 342.05,
    y2: 884.86,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 239.91,
    y1: 885.03,
    x2: 272.42,
    y2: 885.03,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 5006,
    y1: 2985.7,
    x2: 5038.5,
    y2: 2985.7,
    gradientTransform: "translate(-4749.83 -2137.44)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 10266.25,
    y1: 885.03,
    x2: 10298.75,
    y2: 885.03,
    gradientTransform: "translate(-9915.94 1770.06) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 12095.54,
    y1: -4103.85,
    x2: 12128.05,
    y2: -4103.85,
    gradientTransform: "translate(-11761.29 -3255.6) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 9897.7,
    y1: 1105.05,
    x2: 9925.15,
    y2: 1105.05,
    gradientTransform: "translate(-9599.48 -271.45)",
    xlinkHref: "#linear-gradient"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "318.15 895.48 650.07 768.63 1027.05 904.96 1228.57 673.8 1133.74 465.16 1246.36 235.18 995.04 147.46 782.25 308.68 344.23 154.57 295.62 357.28 247.37 547.79 338.3 682.1 318.44 892.66 338.3 682.1 544.57 690.39 658.37 647.72 1027.05 904.96 907.32 683.28 1057.87 659.57 1027.05 904.96 1228.57 673.8 1057.87 659.57 1133.74 465.16 987.93 324.09 1246.36 235.18 987.93 324.09 995.04 147.46 987.93 324.09 782.25 308.68 919.17 562.36 1133.74 465.16 1057.87 659.57 919.17 562.36 907.32 683.28 658.37 647.72 725.94 454.49 919.17 562.36 725.94 454.49 596.73 313.42 782.25 308.68 596.73 313.42 344.23 154.57 539.83 435.52 596.73 313.42 539.83 435.52 658.37 647.72 539.83 435.52 544.57 690.39 403.5 485.31 539.83 435.52 403.5 485.31 295.62 357.28 539.83 435.52 295.62 357.28 403.5 485.31 247.37 547.79 338.3 682.1 403.5 485.31 544.57 690.39 658.37 647.72 650.07 768.63 544.57 690.39 318.15 895.48"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "878.48 570.5 876.06 680.16 903.61 684.09 911.56 682.84 906.61 574.1 878.48 570.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "906.9 574.14 913.37 681.82 929.88 679.4 950.1 675.94 947.17 625.21 927.56 576.65 906.9 574.14"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "940.08 520.03 980.04 550.45 1008.67 452.77 968.71 422.36 940.08 520.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "977.55 441.32 1001.66 459.67 1002.29 457.51 978.18 439.16 977.55 441.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "976.2 445.92 1000.31 464.27 1000.94 462.11 976.83 443.75 976.2 445.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "974.85 450.51 998.96 468.87 999.6 466.7 975.49 448.35 974.85 450.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "973.5 455.11 997.61 473.47 998.25 471.3 974.14 452.95 973.5 455.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "972.16 459.71 996.27 478.06 996.9 475.9 972.79 457.55 972.16 459.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "981.9 472.75 994.92 482.66 995.55 480.5 982.53 470.58 981.9 472.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "968.11 473.5 992.23 491.86 992.86 489.69 968.75 471.34 968.11 473.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "966.77 478.1 990.88 496.45 991.51 494.29 967.4 475.94 966.77 478.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "965.42 482.7 989.53 501.05 990.16 498.89 966.05 480.53 965.42 482.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "958.48 506.36 982.59 524.71 983.23 522.55 959.12 504.2 958.48 506.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "957.14 510.96 981.25 529.31 981.88 527.15 957.77 508.79 957.14 510.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "955.79 515.56 979.9 533.91 980.53 531.75 956.42 513.39 955.79 515.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "964.07 487.29 988.18 505.65 988.82 503.48 964.71 485.13 964.07 487.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "962.72 491.89 986.84 510.25 987.47 508.08 963.36 489.73 962.72 491.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "972.47 504.93 985.49 514.84 986.12 512.68 973.1 502.77 972.47 504.93"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "968.71 422.36 971.81 422.49 1011.96 452.82 1008.67 452.77 968.71 422.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "1011.96 452.82 983.25 549.84 980.04 550.45 1008.67 452.77 1011.96 452.82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M889.28,464.28l-5.43-.24c-7.15-.31-13.67,4.11-16.02,10.87l-13.57,38.94c-2.58,7.4,1.24,15.51,8.59,18.24l15.65,5.81,10.78-73.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 896.83,
    y: 433.77,
    width: 21.85,
    height: 31.29,
    transform: "translate(20.41 -39.06) rotate(2.49)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-60",
    cx: 904.17,
    cy: 430.44,
    r: 27.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M903.9,410.89c-2.21,1.12-4.48,1.96-6.79,2.55,1.1,1.48,2.09,3.08,2.95,4.78,6.57,12.98,3.91,28.21-5.51,38.23-6.69-2.2-12.54-6.95-15.97-13.73-4.9-9.7-3.53-20.93,2.61-29.06,2.24-2.99,5.16-5.55,8.62-7.47.3-.17.61-.34.92-.49,7.11-3.6,15.05-3.81,21.97-1.25-2.49,2.55-5.45,4.74-8.81,6.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-98",
    cx: 864.27,
    cy: 442,
    r: 16.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "925.78 419.71 935.57 426.76 927.34 430.94 925.78 419.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M887.71,464.21l41.7,1.82c5.85.25,10.39,5.2,10.13,11.05l-1.96,44.93,26.35,111.03c.96,4.05-2.22,7.9-6.38,7.72l-57.7-2.51-3.03-38.95-1.69,38.75-29.18-1.27c-4.46-.19-7.78-4.18-7.17-8.6l12-87.3,2.85-65.55c.28-6.46,5.75-11.48,12.21-11.2l1.86.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M940.37,487.27l6.79,75.88,2.16,9.24h0c-21.28,2.67-40.35-13.3-41.46-34.72l7.59-51.49,24.91,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M928.89,466c8.77.38,16.26,6.46,18.45,14.96l14.54,56.58,28.55-25.07,9,10.81-23.84,34.35c-9.71,13.99-31.22,10.93-36.65-5.21l-23.17-68.99c-2.96-8.8,3.84-17.83,13.12-17.43h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 893.67,
    y: 463.41,
    width: 27.27,
    height: 3.94,
    transform: "translate(21.1 -39.03) rotate(2.49)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-60",
    cx: 903.9,
    cy: 436.75,
    r: 6.49
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M991.03,513.2s2.51-4.15,1.68-6.33c-.83-2.18-6.93-9.08-4.79-11.07,2.14-1.99,9.09,7.5,9.09,7.5l2.65-8.84s9.2,5.94,5.71,14.7c-3.49,8.76-7.05,13-7.05,13l-7.3-8.97Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "482.67 442.85 435.39 464.64 440.36 480.93 492.85 475.24 482.67 442.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "482.67 442.85 435.39 464.64 440.36 480.93 492.85 475.24 482.67 442.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M436.45,468.05c-1.7-.87-3.61-.97-4.85-2.61-3.95-2.29-.33,6.17.82,7.51,1.15,2.33-1.82,7.43-.4,9.43,2.57,1.74,4.7-3.71,6.81-3.62,2.54.84-2.29-8.92-2.39-10.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "445.96 376.79 459.58 379.46 440.83 402.29 445.96 376.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "447.07 371.3 440.83 402.29 383.92 383.4 393.66 345.65 406.39 349.74 411.27 361.58 447.07 371.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M406.67,385.08c-.16-.47-2.49-5.53-.55-4.22-.13.31-.13.68-.24.99,1.71.54,3.09-.42,2.73-2.27-.39-2.08-1.93-2.76-3.12-4.21,1.8-.82,3.73-.39,2.99-3.1-.27-.89-.81-1.69-.96-2.63-.13-.8.23-1.68.04-2.41-1.05,0-2.28.61-3.26.28.63-2.03-.27-3.61-.3-5.61-.01-1,.58-1.81.53-2.81-.05-1.16-.92-1.95-1.33-2.99-.57-1.42-.18-.97.37-1.65.31-.37.76-.34.51-.98-.19-.53-1.95-.93-1.42-1.87.22-.41.67-.45,1.09-.31-.07-.59-.31-.98-.25-1.18.08-.47.45-.45.67-.88.04-.08.08-.15.12-.2l-10.51-3.38-9.74,37.75,23.56,7.82c.02-.66.02-1.33,0-1.96-.06-1.37-.4-2.82-.91-4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M403,376.58c-.66,1.26.87,2.76.24,4.01-.22.44-1.31,1.18-1.68.78-.31-.33-.04-2.17.13-2.64.29-.8,1.3-.46,1.31-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M398.31,376.12c-.66,1.26.87,2.76.24,4.01-.22.44-1.31,1.18-1.68.78-.31-.33-.04-2.17.13-2.64.29-.8,1.3-.46,1.31-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M402.19,370.42c.25.18.23.43.21.75-.05.59-.45.58-.6.98-.12.33,0,.6.09.97-.83.37-.52-1.81-.21-2.13.57-.58.65.15.51-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M398.32,370.72c.25.18.23.43.21.75-.05.59-.45.58-.6.98-.12.33,0,.6.09.97-.83.37-.52-1.81-.21-2.13.57-.58.65.15.51-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M401.19,366.18c-.15.72.48,1.64-.07,2.2-.18.18-.71.57-.96.47-.41-.17-.35-1.61-.04-1.88.41-.36,1,.07,1.07-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M399.68,361.32c.37.18,1.44,1.51,1.01,2.1-.22.3-.96.34-1.17.07-.41-.53.02-.81.26-1.08.05-.06.24-.02.31-.1.11-.12.1-.97-.42-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M401.54,356.21c.16-.75-.32-1.61-.29-2.39.02-.47.24-.9.24-1.36-1.45-.44-.82.79-.68,1.66.04.22-.08.48-.03.69.07.34.51.49.76,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M399.79,351.69c.2-.74-1.05-2.13-1.79-1.77-.82.41.56,2.49.68,2.87.07.21-.17.35.15.59.17.13.47.12.65.04.83-.41.17-1.71.31-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M399.09,358.22c-.05.61-.21,1.2-.28,1.81-.04.35.04.83-.09,1.14-.07,0-.22.01-.29,0-.15-.7-.1-1.39.27-1.99.15-.26.39-.44.39-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M402.08,358.73c.46.56,1.15,1.31.88,2.03-.1.28-.38.07-.24.61.12.44.59.67.44,1.19-.2-.02-.39-.04-.59-.05-.13-.95.19-2.15-.37-2.98l-.13-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M405.34,370.41c.33-.04.42.16.48.44.03.15,0,.62-.08.76-.11.19-.41.19-.51.35-.27.43.45,1.21-.39,1.23-.74.02-.72-1.42-.42-1.87.2-.31.78-.32,1.01-.63.19-.26.3-.9,0-1.11l-.08.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M403.47,384.06c-.12.83.67,1.74.44,2.47-.16.52-.83.34-1.32.27-.04-.66.23-1.26.6-1.8.24-.34.51-.59.28-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M395.45,367.61c-.14-.04-.26-.01-.35.09,0,.43.09,4.14-1.02,3.1-.25-.24-.25-1.31-.01-1.59s.75-.11.66-.62l.72-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M395.69,354.43c-.52.94-.15,2.19-.67,3.19-.17.32-.94,1.57-1.45.86-.31-.43.24-.58.46-.86.43-.56.23-1.53.72-2.02l.95-1.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "502.95 403.98 495.91 368.49 492.76 369.11 502.34 353.97 518.98 350.67 530.42 408.39 502.95 403.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M531.43,390.47c-7.25,10.22-21.4,10.34-32.26,13.56-5.82,1.86-12.62-.89-18.07,2.34-8.64,7.89-12.92,21.91-14.48,33.34-1.97,14.45,17.04,78.28,15.2,92.63l76.07-2.39s-6.65-2.79-6.35-8.94c1.38-27.73,11.93-106.36,10.91-120.59-1.24-17.38-31.03-9.95-31.03-9.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M497.58,343.2c-2.23,4.72,1.65,9.41,6.16,15.63,4.52,6.22,6.05,8.43,1.51,16.45l-9.79-2.99s-8.72,12.34.73,16.93c9.45,4.59,10.7-2.89,12.14-7.22,1.44-4.33,5.71-15.91,5.71-15.91,0,0,4.65.83,3.38,4.36-1.27,3.54-2.93,1.97-2.93,1.97,0,0-3.9,3.91,1.39,8.85,5.28,4.94,14.07-2.28,15.28-6.09,1.21-3.82,6.45-19.37,2.17-21.44-4.28-2.07-7.55.55-11.47-7.8-3.92-8.34-21.64-8.33-24.29-2.74Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M415.77,396.26c9.04,15.9,10.88,33.77,23.7,47.61,11.34-15.37,27.59-29.14,43.96-38.52,7.69,11.85,14.09,24.19,20.68,36.67-18.75,19.03-39.47,31.54-66.52,34.04-29.26-20.64-25.15-44.64-28.43-75.34,2.21-1.49,4.41-2.97,6.62-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M410.33,400.19c-1.96-3.04-3.92-6.08-5.88-9.11-.51-.79-1.03-1.61-1.15-2.55s-.73-3.54.14-3.88c.89-.34,2.93,1.72,3.53,2.47.6.74.92,1.67,1.39,2.5,1.27,2.22,3.76,3.69,6.32,3.74-.07,1.23-.13,2.46-.2,3.69l-4.16,3.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "562.13 683.69 544.91 690.15 521.25 655.76 519.14 552.45 519.13 552.04 519.07 552.41 510.91 640.73 480.96 597.58 483.65 532.28 483.65 532.25 550.74 529.24 550.77 530.16 551.77 563.03 562.13 683.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M495.6,552.26c-5.32-2.78-7.93-7.34-9.15-11.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-20",
    points: "531.05 540.93 547.74 539.78 547.32 544.01 532.45 545.01"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1238.63,
    cy: 231.7,
    r: 31.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 1220.37,
    y: 254.58,
    width: 36.53,
    height: 24.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1220.37,
    y: 272.66,
    width: 36.53,
    height: 15.13
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-27",
    points: "1243.29 272.66 1243.29 228.66 1254.08 228.66 1254.08 242.36 1238.45 242.36 1222.81 242.36 1222.81 228.66 1233.61 228.66 1233.61 272.66"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1166.61,
    y: 226.88,
    width: 32.5,
    height: 6.01,
    rx: 3.01,
    ry: 3.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 1182.86,
    y: 190.11,
    width: 32.5,
    height: 6.01,
    rx: 3.01,
    ry: 3.01,
    transform: "translate(487.76 -791.34) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1277,
    y: 226.88,
    width: 32.5,
    height: 6.01,
    rx: 3.01,
    ry: 3.01,
    transform: "translate(2586.5 459.78) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 1260.95,
    y: 190.11,
    width: 32.5,
    height: 6.01,
    rx: 3.01,
    ry: 3.01,
    transform: "translate(2316.87 -573.45) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 1224.91,
    y: 175.46,
    width: 27.46,
    height: 6.01,
    rx: 3.01,
    ry: 3.01,
    transform: "translate(1417.1 -1060.17) rotate(90)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 1006.29,
    y: 103.01,
    width: 46.68,
    height: 75.09,
    transform: "translate(2059.25 281.12) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 1009.67,
    y: 106.74,
    width: 39.69,
    height: 29.44,
    transform: "translate(2059.02 242.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 1044.03,
    cy: 149.9,
    r: 5.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 1044.03,
    cy: 165.7,
    r: 5.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1033.07,
    y: 144.04,
    width: 1.35,
    height: 11.62,
    transform: "translate(2067.49 299.7) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1027.16,
    y: 144.04,
    width: 1.35,
    height: 11.62,
    transform: "translate(2055.67 299.7) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1021.25,
    y: 144.04,
    width: 1.35,
    height: 11.62,
    transform: "translate(2043.86 299.7) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1033.07,
    y: 159.9,
    width: 1.35,
    height: 11.62,
    transform: "translate(2067.49 331.41) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1027.16,
    y: 159.9,
    width: 1.35,
    height: 11.62,
    transform: "translate(2055.67 331.41) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1021.25,
    y: 159.9,
    width: 1.35,
    height: 11.62,
    transform: "translate(2043.86 331.41) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1015.57,
    y: 144.04,
    width: 1.35,
    height: 11.62,
    transform: "translate(2032.5 299.7) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1009.67,
    y: 144.04,
    width: 1.35,
    height: 11.62,
    transform: "translate(2020.68 299.7) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1015.57,
    y: 159.9,
    width: 1.35,
    height: 11.62,
    transform: "translate(2032.5 331.41) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1009.67,
    y: 159.9,
    width: 1.35,
    height: 11.62,
    transform: "translate(2020.68 331.41) rotate(-180)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 994.24,
    y: 114.01,
    width: 46.68,
    height: 75.09,
    transform: "translate(2035.15 303.11) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 997.61,
    y: 117.73,
    width: 39.69,
    height: 29.44,
    transform: "translate(2034.92 264.91) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 1031.97,
    cy: 160.89,
    r: 5.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 1031.97,
    cy: 176.7,
    r: 5.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1021.02,
    y: 155.04,
    width: 1.35,
    height: 11.62,
    transform: "translate(2043.38 321.69) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1015.11,
    y: 155.04,
    width: 1.35,
    height: 11.62,
    transform: "translate(2031.57 321.69) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1009.2,
    y: 155.04,
    width: 1.35,
    height: 11.62,
    transform: "translate(2019.75 321.69) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1021.02,
    y: 170.89,
    width: 1.35,
    height: 11.62,
    transform: "translate(2043.38 353.4) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1015.11,
    y: 170.89,
    width: 1.35,
    height: 11.62,
    transform: "translate(2031.57 353.4) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1009.2,
    y: 170.89,
    width: 1.35,
    height: 11.62,
    transform: "translate(2019.75 353.4) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1003.52,
    y: 155.04,
    width: 1.35,
    height: 11.62,
    transform: "translate(2008.39 321.69) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 997.61,
    y: 155.04,
    width: 1.35,
    height: 11.62,
    transform: "translate(1996.58 321.69) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1003.52,
    y: 170.89,
    width: 1.35,
    height: 11.62,
    transform: "translate(2008.39 353.4) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 997.61,
    y: 170.89,
    width: 1.35,
    height: 11.62,
    transform: "translate(1996.58 353.4) rotate(-180)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 898.99,
    y: 127.21,
    width: 127.17,
    height: 76.84,
    transform: "translate(1925.15 331.27) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 902.37,
    y: 130.94,
    width: 120.19,
    height: 49.96,
    transform: "translate(1924.92 311.84) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 956.23,
    cy: 163.61,
    r: 7.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 997.46,
    cy: 163.61,
    r: 7.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 934.15,
    cy: 143.87,
    r: 7.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 918.78,
    cy: 163.61,
    r: 7.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 1012.25,
    cy: 194.88,
    r: 5.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 960.64,
    cy: 191.82,
    r: 2.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 950.64,
    cy: 191.82,
    r: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1001.29,
    y: 189.03,
    width: 1.35,
    height: 11.62,
    transform: "translate(2003.93 389.67) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 995.38,
    y: 189.03,
    width: 1.35,
    height: 11.62,
    transform: "translate(1992.11 389.67) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 989.47,
    y: 189.03,
    width: 1.35,
    height: 11.62,
    transform: "translate(1980.3 389.67) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 983.57,
    y: 189.03,
    width: 1.35,
    height: 11.62,
    transform: "translate(1968.48 389.67) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 977.66,
    y: 189.03,
    width: 1.35,
    height: 11.62,
    transform: "translate(1956.67 389.67) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 928.57,
    y: 189.03,
    width: 13.27,
    height: 0.52,
    transform: "translate(1870.41 378.58) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 912.14,
    y: 189.03,
    width: 13.27,
    height: 0.52,
    transform: "translate(1837.56 378.58) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 928.57,
    y: 191.56,
    width: 13.27,
    height: 0.52,
    transform: "translate(1870.41 383.63) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 912.14,
    y: 191.56,
    width: 13.27,
    height: 0.52,
    transform: "translate(1837.56 383.63) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 928.57,
    y: 194.08,
    width: 13.27,
    height: 0.52,
    transform: "translate(1870.41 388.69) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 912.14,
    y: 194.08,
    width: 13.27,
    height: 0.52,
    transform: "translate(1837.56 388.69) rotate(-180)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 986.02,
    cy: 320.59,
    r: 10.82
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1131.75,
    cy: 461.07,
    r: 10.82
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-86",
    cx: 313.5,
    cy: 892.22,
    r: 10.82
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-66",
    cx: 245.42,
    cy: 546.85,
    r: 11.03
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-107",
    cx: 342.95,
    cy: 151.55,
    r: 10.82
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-104",
    cx: 782.34,
    cy: 306.68,
    r: 10.82
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-77",
    cx: 593.44,
    cy: 309.77,
    r: 10.82
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-70",
    cx: 645.63,
    cy: 764.16,
    r: 10.82
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 1027.84,
    cy: 901.46,
    r: 10.82
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M240.68,278h106.81c1.48,0,2.69,1.21,2.69,2.69v3.47h-112.19v-3.47c0-1.48,1.21-2.69,2.69-2.69Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-35",
    points: "350.18 284.16 350.18 384.81 237.99 384.81 237.99 284.16"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M249.75,306.01c.02-.09.04-.18.06-.27.84-3.95,2.98-7.51,6.08-10.09,3.12-2.6,7.03-4.07,11.09-4.17.03,0,.06,0,.08,0,.03,0,.05,0,.08,0,.02,0,.03,0,.05,0l.06,4.73c-.05,0-.11,0-.16,0-3.34.08-6.66,1.4-9.19,3.97-1.85,1.87-3.03,4.16-3.55,6.56-.01.06-.03.13-.04.19l-4.57-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M267.1,296.19l-.12-4.72h0s.06,0,.08,0c.03,0,.05,0,.08,0,.02,0,.03,0,.05,0,.04,0,.08,0,.12,0,6.25-.04,12.07,3.18,15.37,8.43,0,0,0,0,0,0,.06.09.11.17.16.26.06.09.11.18.16.27.1.18.2.35.3.53l-4.16,2.23c-.14-.27-.3-.53-.46-.79-.53-.84-1.17-1.64-1.91-2.36-2.64-2.6-6.08-3.88-9.52-3.85-.05,0-.11,0-.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M280.74,309.43c0-.07,0-.13,0-.2-.05-2.08-.58-4.16-1.6-6.04-.14-.27-.3-.53-.46-.79l4-2.51s0,0,0,0c.06.09.11.17.16.26.06.09.11.18.16.27.1.18.2.35.3.53,1.38,2.58,2.12,5.46,2.14,8.4,0,.02,0,.04,0,.06h-.03s-4.67.01-4.67.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M267.57,327.55l-.04-4.68c.05,0,.11,0,.16,0,3.35-.07,6.67-1.4,9.21-3.96,2.59-2.62,3.87-6.05,3.85-9.47,0-.07,0-.13,0-.2l4.67-.11c0,.1,0,.2,0,.3.03,4.77-1.84,9.37-5.19,12.77-3.29,3.33-7.75,5.25-12.43,5.35-.06,0-.11,0-.17,0h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M252.12,319.07c-.08-.12-.15-.25-.23-.37-.07-.11-.14-.23-.2-.35,0-.02-.02-.03-.03-.05-.03-.05-.06-.1-.08-.15-.03-.05-.06-.1-.08-.15h0s4.12-2.2,4.12-2.2c.14.27.3.54.46.8.54.87,1.19,1.68,1.95,2.43,2.63,2.6,6.07,3.88,9.5,3.85.05,0,.11,0,.16,0l.1,4.67h0c-.06,0-.12,0-.17,0h-.04s-.08,0-.12,0c-6.25.02-12.05-3.22-15.34-8.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M252.12,319.07c-.08-.12-.15-.25-.23-.37-.07-.11-.14-.23-.2-.35,0-.02-.02-.03-.03-.05-.03-.05-.06-.1-.08-.15-.03-.05-.06-.1-.08-.15-.89-1.68-1.52-3.49-1.84-5.36-.4-2.29-.35-4.63.14-6.9h.01s4.55.98,4.55.98c-.01.06-.03.13-.04.19-.6,2.99-.16,6.15,1.3,8.89.14.27.3.54.46.8l-3.96,2.47Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.91,306.83c.01-.07.03-.14.04-.21.64-3.02,2.28-5.74,4.65-7.72,2.39-1.99,5.37-3.11,8.48-3.19.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.01,0,.02,0,.04,0l.05,3.61s-.08,0-.12,0c-2.55.06-5.09,1.07-7.02,3.03-1.41,1.43-2.32,3.18-2.71,5.01,0,.05-.02.1-.03.14l-3.49-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M267.17,299.33l-.09-3.61h0s.04,0,.06,0c.02,0,.04,0,.06,0,.01,0,.02,0,.04,0,.03,0,.06,0,.09,0,4.78-.03,9.23,2.43,11.75,6.44,0,0,0,0,0,0,.04.07.08.13.12.2.04.07.08.14.12.21.08.13.16.27.23.41l-3.18,1.71c-.11-.21-.23-.41-.35-.6-.41-.64-.89-1.25-1.46-1.81-2.02-1.99-4.65-2.97-7.28-2.94-.04,0-.08,0-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M277.61,309.45c0-.05,0-.1,0-.15-.04-1.59-.44-3.18-1.22-4.62-.11-.21-.23-.41-.35-.6l3.06-1.92s0,0,0,0c.04.07.08.13.12.2.04.07.08.14.12.21.08.13.16.27.23.41,1.06,1.97,1.62,4.18,1.64,6.42,0,.02,0,.03,0,.05h-.02s-3.57,0-3.57,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M267.54,323.3l-.03-3.57s.08,0,.12,0c2.56-.06,5.1-1.07,7.04-3.03,1.98-2.01,2.96-4.63,2.94-7.24,0-.05,0-.1,0-.15l3.57-.08c0,.08,0,.15,0,.23.02,3.65-1.4,7.16-3.97,9.76-2.52,2.55-5.93,4.02-9.51,4.09-.04,0-.09,0-.13,0h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M255.72,316.82c-.06-.1-.12-.19-.17-.29-.05-.09-.1-.18-.15-.27,0-.01-.01-.02-.02-.04-.02-.04-.04-.08-.06-.12-.02-.04-.04-.08-.06-.12h0s3.15-1.68,3.15-1.68c.11.21.23.41.35.61.41.66.91,1.29,1.49,1.86,2.01,1.99,4.64,2.96,7.26,2.94.04,0,.08,0,.12,0l.08,3.57h0s-.09,0-.13,0h-.03s-.06,0-.09,0c-4.78.01-9.22-2.46-11.73-6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M255.72,316.82c-.06-.1-.12-.19-.17-.29-.05-.09-.1-.18-.15-.27,0-.01-.01-.02-.02-.04-.02-.04-.04-.08-.06-.12-.02-.04-.04-.08-.06-.12-.68-1.28-1.16-2.67-1.41-4.1-.3-1.75-.27-3.54.11-5.27h.01s3.48.75,3.48.75c0,.05-.02.1-.03.14-.46,2.29-.12,4.7,1,6.8.11.21.23.41.35.61l-3.03,1.89Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 317.88,
    cy: 309.43,
    r: 18.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M328.88,307.73c0-.1-.02-.12-.12-.12-.66,0-1.32,0-1.99,0-.07,0-.11-.02-.13-.09-.21-.84-.54-1.63-.98-2.38-.04-.07-.04-.11.02-.16.47-.47.94-.94,1.42-1.41.06-.06.06-.09,0-.15-.93-.92-1.85-1.85-2.78-2.78-.06-.06-.09-.07-.16,0-.46.47-.94.94-1.4,1.41-.06.06-.11.07-.18.02-.74-.44-1.52-.77-2.36-.98-.08-.02-.1-.05-.1-.13,0-.66,0-1.32,0-1.98,0-.09-.02-.13-.12-.13-1.3,0-2.6,0-3.91,0-.09,0-.12.02-.12.12,0,.66,0,1.32,0,1.99,0,.07-.02.11-.09.13-.84.21-1.63.54-2.38.98-.07.04-.11.04-.16-.02-.47-.47-.94-.94-1.41-1.41-.06-.06-.09-.06-.15,0-.92.93-1.85,1.85-2.78,2.78-.07.07-.06.1,0,.17.47.47.94.94,1.41,1.4.06.06.06.09.02.16-.44.74-.77,1.53-.98,2.37-.02.08-.05.1-.13.1-.66,0-1.32,0-1.98,0-.09,0-.13.02-.13.12,0,1.3,0,2.6,0,3.91,0,.09.02.12.12.12.66,0,1.32,0,1.99,0,.07,0,.11.01.13.09.21.84.53,1.63.98,2.38.04.07.04.11-.02.16-.48.47-.95.95-1.42,1.42-.05.05-.05.08,0,.13.94.93,1.87,1.87,2.8,2.8.06.06.08.05.13,0,.47-.48.95-.95,1.42-1.42.06-.06.09-.06.16-.02.74.44,1.53.77,2.37.98.08.02.1.05.1.13,0,.66,0,1.32,0,1.99,0,.1.03.12.12.12.65,0,1.3,0,1.95,0s1.3,0,1.95,0c.09,0,.12-.02.12-.12,0-.66,0-1.32,0-1.99,0-.07.02-.11.09-.13.84-.21,1.63-.54,2.38-.98.07-.04.11-.04.16.02.47.47.94.94,1.41,1.41.06.06.09.06.15,0,.93-.93,1.85-1.86,2.79-2.79.06-.06.05-.09,0-.15-.47-.47-.94-.94-1.41-1.41-.06-.06-.06-.09-.02-.16.44-.74.77-1.53.98-2.37.02-.08.05-.1.13-.1.66,0,1.32,0,1.98,0,.09,0,.13-.02.13-.12,0-1.3,0-2.6,0-3.91ZM318.05,316.37c-3.68.02-6.69-3.01-6.69-6.69,0-3.67,3.01-6.68,6.69-6.68,3.68,0,6.69,3.01,6.69,6.69,0,3.68-3.01,6.7-6.69,6.67Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M250.42,333.87l36.07.13c2.62,0,4.74,2.14,4.74,4.76l-.02,9.87c0,2.62-2.14,4.74-4.76,4.74l-36.07-.13c-2.62,0-4.74-2.14-4.74-4.76l.02-9.87c0-2.62,2.14-4.74,4.76-4.74Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 285.13,
    y1: 346.04,
    x2: 270.65,
    y2: 345.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 285.14,
    y1: 341.32,
    x2: 264.45,
    y2: 341.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 256.24,
    cy: 342.5,
    r: 4.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M299.87,333.87l36.07.13c2.62,0,4.74,2.14,4.74,4.76l-.02,9.87c0,2.62-2.14,4.74-4.76,4.74l-36.07-.13c-2.62,0-4.74-2.14-4.74-4.76l.02-9.87c0-2.62,2.14-4.74,4.76-4.74Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 334.58,
    y1: 346.04,
    x2: 320.09,
    y2: 345.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 334.59,
    y1: 341.32,
    x2: 313.9,
    y2: 341.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 305.69,
    cy: 342.5,
    r: 4.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M250.42,358.6l36.07.13c2.62,0,4.74,2.14,4.74,4.76l-.02,9.87c0,2.62-2.14,4.74-4.76,4.74l-36.07-.13c-2.62,0-4.74-2.14-4.74-4.76l.02-9.87c0-2.62,2.14-4.74,4.76-4.74Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 285.13,
    y1: 370.77,
    x2: 270.65,
    y2: 370.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 285.14,
    y1: 366.05,
    x2: 264.45,
    y2: 365.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 256.24,
    cy: 367.23,
    r: 4.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M299.87,358.6l36.07.13c2.62,0,4.74,2.14,4.74,4.76l-.02,9.87c0,2.62-2.14,4.74-4.76,4.74l-36.07-.13c-2.62,0-4.74-2.14-4.74-4.76l.02-9.87c0-2.62,2.14-4.74,4.76-4.74Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 334.58,
    y1: 370.77,
    x2: 320.09,
    y2: 370.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 334.59,
    y1: 366.05,
    x2: 313.9,
    y2: 365.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-96",
    cx: 305.69,
    cy: 367.23,
    r: 4.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 242.3,
    cy: 281.08,
    r: 1.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 247.51,
    cy: 281.08,
    r: 1.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 252.73,
    cy: 281.08,
    r: 1.88
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 265.27,
    y: 639.86,
    width: 132.87,
    height: 84.96,
    rx: 1.24,
    ry: 1.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 265.27,
    y: 639.86,
    width: 132.87,
    height: 84.96,
    rx: 1.24,
    ry: 1.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 266.38,
    y: 639.86,
    width: 130.66,
    height: 83.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 266.38,
    y: 639.86,
    width: 95.01,
    height: 83.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 364.65,
    y: 644.97,
    width: 15.25,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 369.83,
    y: 651.23,
    width: 15.25,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 364.65,
    y: 657.48,
    width: 26.57,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 367.76,
    y: 663.74,
    width: 10.65,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 382.25,
    y: 663.74,
    width: 10.65,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 364.65,
    y: 670,
    width: 19.37,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 371.21,
    y: 676.25,
    width: 15.25,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 367.76,
    y: 682.45,
    width: 15.83,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 387.6,
    y: 682.45,
    width: 4.76,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 364.65,
    y: 688.77,
    width: 15.25,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 383.6,
    y: 688.77,
    width: 5.9,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 372.28,
    y: 695.02,
    width: 15.25,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 368.78,
    y: 701.28,
    width: 15.25,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 388.4,
    y: 701.28,
    width: 2.38,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 364.65,
    y: 707.53,
    width: 11.75,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 376.4,
    y: 713.79,
    width: 13.47,
    height: 3.22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "273.19 716.52 285.91 660.51 300.13 716.68 273.19 716.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "294.73 716.65 307.24 649.42 321.68 716.81 294.73 716.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "312.98 716.76 323.24 661.59 335.1 716.89 312.98 716.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "325.98 716.84 339.4 660.15 354.32 717.01 325.98 716.84"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M830.27,697.53l60.14.22c4.37.01,7.91,3.56,7.9,7.93l-.04,16.46c-.01,4.37-3.56,7.91-7.93,7.9l-60.14-.22c-4.37-.01-7.91-3.56-7.9-7.93l.04-16.46c.01-4.37,3.56-7.91,7.93-7.9Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 888.15,
    y1: 717.82,
    x2: 864,
    y2: 717.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 888.17,
    y1: 709.96,
    x2: 853.67,
    y2: 709.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-55",
    cx: 839.99,
    cy: 711.93,
    r: 7.63
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1057.33,311.29l60.14.22c4.37.01,7.91,3.56,7.9,7.93l-.04,16.46c-.01,4.37-3.56,7.91-7.93,7.9l-60.14-.22c-4.37-.01-7.91-3.56-7.9-7.93l.04-16.46c.01-4.37,3.56-7.91,7.93-7.9Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 1115.21,
    y1: 331.58,
    x2: 1091.06,
    y2: 331.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 1115.23,
    y1: 323.72,
    x2: 1080.73,
    y2: 323.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 1067.04,
    cy: 325.68,
    r: 7.63
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M280.24,465.61l60.14.22c4.37.01,7.91,3.56,7.9,7.93l-.04,16.46c-.01,4.37-3.56,7.91-7.93,7.9l-60.14-.22c-4.37-.01-7.91-3.56-7.9-7.93l.04-16.46c.01-4.37,3.56-7.91,7.93-7.9Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 338.12,
    y1: 485.9,
    x2: 313.97,
    y2: 485.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 338.14,
    y1: 478.04,
    x2: 303.64,
    y2: 477.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-96",
    cx: 289.95,
    cy: 480.01,
    r: 7.63
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1003.46,
    y: 699.08,
    width: 141.95,
    height: 130.8,
    rx: 5.35,
    ry: 5.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 1007.03,
    y: 694.44,
    width: 141.95,
    height: 130.8,
    rx: 5.35,
    ry: 5.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M1010.96,819.9v-120.1c0-2.96,2.4-5.35,5.35-5.35h-3.92c-2.96,0-5.35,2.4-5.35,5.35v120.1c0,2.96,2.4,5.35,5.35,5.35h3.92c-2.96,0-5.35-2.4-5.35-5.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 1099.33,
    y: 726.79,
    width: 19.47,
    height: 17.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 1040.92,
    y: 780.3,
    width: 19.47,
    height: 17.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 1040.92,
    y: 744.62,
    width: 19.47,
    height: 17.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 1118.8,
    y: 744.62,
    width: 19.47,
    height: 17.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1021.62,
    y: 744.62,
    width: 19.47,
    height: 17.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 1079.86,
    y: 762.46,
    width: 19.47,
    height: 17.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 1060.39,
    y: 798.13,
    width: 19.47,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 1021.62,
    y: 726.79,
    width: 19.47,
    height: 17.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1143.63,694.44h-131.24c-2.96,0-5.35,2.4-5.35,5.35v16.29h141.95v-16.29c0-2.96-2.4-5.35-5.35-5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1007.03,699.8v16.29h3.92v-16.29c0-2.96,2.4-5.35,5.35-5.35h-3.92c-2.96,0-5.35,2.4-5.35,5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1016.31,825.25c-2.96,0-5.35-2.4-5.35-5.35v-120.1c0-2.96,2.4-5.35,5.35-5.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1007.03,
    y1: 716.09,
    x2: 1148.98,
    y2: 716.09
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1035.98,
    y: 712.25,
    width: 87.76,
    height: 116.83,
    transform: "translate(1850.53 -309.19) rotate(90)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1021.44,
    y1: 726.79,
    x2: 1138.27,
    y2: 726.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1021.44,
    y1: 744.62,
    x2: 1138.27,
    y2: 744.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1021.44,
    y1: 762.46,
    x2: 1138.27,
    y2: 762.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1021.44,
    y1: 780.3,
    x2: 1138.27,
    y2: 780.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1021.44,
    y1: 798.13,
    x2: 1138.27,
    y2: 798.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1040.92,
    y1: 726.79,
    x2: 1040.92,
    y2: 814.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1060.39,
    y1: 726.79,
    x2: 1060.39,
    y2: 814.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1079.86,
    y1: 726.79,
    x2: 1079.86,
    y2: 814.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1099.33,
    y1: 726.79,
    x2: 1099.33,
    y2: 814.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1118.8,
    y1: 726.79,
    x2: 1118.8,
    y2: 814.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1028.72,746.87c-2.61-7.05.07-11.88.07-11.88h13.15s-1.65,5.7.82,11.88h-14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1046.16,747.95h-14.05s-4.38-5.59-3.33-12.96h13.15c-1.25,6.48,4.22,12.96,4.22,12.96Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1031.12,
    y1: 737.9,
    x2: 1035.81,
    y2: 737.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1031.36,
    y1: 740.35,
    x2: 1041.17,
    y2: 740.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1036.55,
    y1: 743.08,
    x2: 1041.17,
    y2: 743.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1031.95,
    y1: 743.08,
    x2: 1034.76,
    y2: 743.08
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1067.76,771.98c-2.61-7.05.07-11.88.07-11.88h13.15s-1.65,5.7.82,11.88h-14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1085.21,773.07h-14.05s-4.38-5.59-3.33-12.96h13.15c-1.25,6.48,4.22,12.96,4.22,12.96Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1070.17,
    y1: 763.02,
    x2: 1074.86,
    y2: 763.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1070.4,
    y1: 765.47,
    x2: 1080.22,
    y2: 765.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1071,
    y1: 768.19,
    x2: 1080.22,
    y2: 768.19
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1112.63,799.02c-2.61-7.05.07-11.88.07-11.88h13.15s-1.65,5.7.82,11.88h-14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1130.07,800.1h-14.05s-4.38-5.59-3.33-12.96h13.15c-1.25,6.48,4.22,12.96,4.22,12.96Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1115.45,
    y1: 791.04,
    x2: 1123.21,
    y2: 791.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1115.69,
    y1: 793.48,
    x2: 1125.5,
    y2: 793.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1116.28,
    y1: 796.21,
    x2: 1125.5,
    y2: 796.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1099.04,773.09c-2.61-7.05.07-11.88.07-11.88h13.15s-1.65,5.7.82,11.88h-14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1116.48,774.17h-14.05s-4.38-5.59-3.33-12.96h13.15c-1.25,6.48,4.22,12.96,4.22,12.96Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1101.44,
    y1: 764.13,
    x2: 1106.13,
    y2: 764.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1109.19,
    y1: 766.57,
    x2: 1111.49,
    y2: 766.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1101.68,
    y1: 766.57,
    x2: 1106.88,
    y2: 766.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1102.27,
    y1: 769.3,
    x2: 1111.49,
    y2: 769.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1093.32,815.97c-2.61-7.05.07-11.88.07-11.88h13.15s-1.65,5.7.82,11.88h-14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1110.76,817.06h-14.05s-4.38-5.59-3.33-12.96h13.15c-1.25,6.48,4.22,12.96,4.22,12.96Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-25",
    points: "1097.46 809.88 1101.47 812.79 1104.74 806.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1101.75,725.99c10-2.04,19.63,1.14,20.87,7.23,1.24,6.09-4.44,12.38-12.69,14.07-8.25,1.68-15.94-1.89-17.18-7.98-.69-3.37,1.52-9.06,8.18-10.42"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 1040.92,
    cy: 699.22,
    r: 4.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1037.28,
    y: 685.96,
    width: 7.27,
    height: 16.77,
    rx: 3.57,
    ry: 3.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 1118.8,
    cy: 699.22,
    r: 4.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1115.17,
    y: 685.96,
    width: 7.27,
    height: 16.77,
    rx: 3.57,
    ry: 3.57
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 311.94,
    cy: 886.84,
    r: 31.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 293.68,
    y: 909.72,
    width: 36.53,
    height: 24.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 293.68,
    y: 927.8,
    width: 36.53,
    height: 15.13
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-27",
    points: "316.6 927.8 316.6 883.8 327.39 883.8 327.39 897.5 311.76 897.5 296.12 897.5 296.12 883.8 306.91 883.8 306.91 927.8"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 239.91,
    y: 882.02,
    width: 32.5,
    height: 6.01,
    rx: 3.01,
    ry: 3.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 256.16,
    y: 845.25,
    width: 32.5,
    height: 6.01,
    rx: 3.01,
    ry: 3.01,
    transform: "translate(679.59 55.82) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 350.31,
    y: 882.02,
    width: 32.5,
    height: 6.01,
    rx: 3.01,
    ry: 3.01,
    transform: "translate(733.11 1770.06) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 334.26,
    y: 845.25,
    width: 32.5,
    height: 6.01,
    rx: 3.01,
    ry: 3.01,
    transform: "translate(1198.16 1200.21) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 298.21,
    y: 830.6,
    width: 27.46,
    height: 6.01,
    rx: 3.01,
    ry: 3.01,
    transform: "translate(1145.54 521.67) rotate(90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentManagement);
export default __webpack_public_path__ + "static/media/talent-management.7589456e33eb4fd56e402d5e477ed019.svg";
export { ForwardRef as ReactComponent };